/* eslint-disable */
import React from 'react'

const BellIcon = ({ width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 24 24"
    version="1.1"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    width={width}
    height={height}
    fill={fill}
  >
    <path
      d="M23.5 19.5c-1.4 0-2.5-1.1-2.5-2.5v-5.5c0-3.6-2.2-7-5.6-8.3C15 1.6 13.6.5 12 .5c-1.6 0-3 1.1-3.4 2.7C5.2 4.5 3 7.9 3 11.5V17c0 1.4-1.1 2.5-2.5 2.5-.3 0-.5.2-.5.5s.2.5.5.5h8.1c.2 1.7 1.7 3 3.4 3s3.2-1.3 3.4-3h8.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-11.5 3c-1.2 0-2.2-.9-2.4-2h4.9c-.3 1.1-1.3 2-2.5 2zm-9.1-3C3.6 18.9 4 18 4 17v-5.5C4 8.2 6.1 5.2 9.2 4c.2-.1.3-.2.3-.4.2-1.2 1.2-2.1 2.5-2.1 1.2 0 2.3.9 2.5 2.1 0 .2.1.3.3.4 3.1 1.2 5.2 4.2 5.2 7.5V17c0 1 .4 1.9 1.1 2.5H2.9z"
      className="st0"
    ></path>
  </svg>
)

export default BellIcon
